import { render, staticRenderFns } from "./SelectTemplateDropdown.vue?vue&type=template&id=255cfc32&scoped=true"
import script from "./SelectTemplateDropdown.vue?vue&type=script&lang=js"
export * from "./SelectTemplateDropdown.vue?vue&type=script&lang=js"
import style0 from "./SelectTemplateDropdown.vue?vue&type=style&index=0&id=255cfc32&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255cfc32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255cfc32')) {
      api.createRecord('255cfc32', component.options)
    } else {
      api.reload('255cfc32', component.options)
    }
    module.hot.accept("./SelectTemplateDropdown.vue?vue&type=template&id=255cfc32&scoped=true", function () {
      api.rerender('255cfc32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/SelectTemplateDropdown.vue"
export default component.exports